import { lazy } from 'react';
import { TenantRouteMeta } from '../types';

const DataSources = lazy(() => import('../../pages/DataSources/DataSources'));
const DataSourceEdit = lazy(() => import('../../pages/DataSources/DataSourceEdit'));
const CanonicalMapping = lazy(() => import('../../pages/CanonicalMapping/CanonicalMapping'));

// PrototypeV3 screens — static reference pages for unbuilt features.
// Gated behind devOnly so they don't ship to production.
const V3Lookups = lazy(() => import('../../pages/PrototypeV3/screens/Lookups'));
const V3Dimensions = lazy(() => import('../../pages/PrototypeV3/screens/Dimensions'));

export const integrationsRoutes: TenantRouteMeta[] = [
  {
    path: 'integrations/sources',
    element: <DataSources />,
    role: 'admin',
    permission: 'data_integrations',
    sidebar: { group: 'data-integrations', label: 'Sources & Versions', order: 1 },
  },
  {
    path: 'integrations/sources/:sourceCode',
    element: <DataSourceEdit />,
    permission: 'data_integrations',
    // Nested detail page — no sidebar entry.
  },
  {
    path: 'integrations/canonical',
    element: <CanonicalMapping />,
    role: 'admin',
    permission: 'data_integrations',
    sidebar: { group: 'data-integrations', label: 'Canonical Mapping', order: 2 },
  },
  {
    path: 'integrations/lookups',
    element: <V3Lookups />,
    devOnly: true,
    role: 'admin',
    permission: 'data_integrations',
    sidebar: { group: 'data-integrations', label: 'Lookups', order: 3 },
  },
  {
    path: 'integrations/dimensions',
    element: <V3Dimensions />,
    devOnly: true,
    role: 'admin',
    permission: 'data_integrations',
    sidebar: { group: 'data-integrations', label: 'Dimensions', order: 4 },
  },
];
